module.exports = __webpack_public_path__ + "img/stretch--genre4_title.cd18810d.png";